import { createAsyncThunk } from "@reduxjs/toolkit";

import { isLoggedInRequest } from "@api/actions/auth";

const WHO_AM_I = "WHO_AM_I";

export const checkIsLoggedIn = createAsyncThunk(
  `USER/${WHO_AM_I}`,
  async () => {
    try {
      const response = await isLoggedInRequest();
      return response.data;
    } catch (err) {
      console.error(err);
    }
  },
);
